module.exports = __webpack_public_path__ + "static/media/203_SHOT_093.65bb60c4.webp";